import {
	Button,
	Checkbox,
	FormControlLabel,
	Grid,
	TableCell,
	TableRow,
	WithStyles,
} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TextField from '@material-ui/core/TextField';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
	IApprovalStayMealData,
	IStayMealDateList,
	setApprovalStayMealList,
	setClassStayMealDialog,
	setStayMealCommment,
} from 'src/actions/search';
import MessageDialog from 'src/components/MessageDialog';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
const styles = () =>
	createStyles({
		button: {
			margin: '15px',
		},
		tableStyle: {
			border: '1px',
			borderBlock: '1',
			tableLayout: 'fixed',
		},

		CellBorder: {
			border: '1px solid white',
		},

		cellgreyborder: {
			border: '1px solid rgb(247, 247, 247)',
		},

		whiteCell: {
			height: '48px',
			padding: '5px 16px',
		},

		greyCell: {
			backgroundColor: 'rgb(247, 247, 247)',
			height: '48px',
			padding: '5px 16px',
		},

		cellOfTitle: {
			backgroundColor: 'white',
			padding: '5px 16px',
		},

		greycellOfTitle: {
			backgroundColor: 'rgb(247, 247, 247)',
			padding: '5px 16px',
		},

		cellBorderOftitle: {
			border: '1px solid white',
			verticalAlign: 'top !important',
		},
		cellgreyBorderOftitle: {
			border: '1px solid rgb(247, 247, 247)',
			verticalAlign: 'top !important',
		},
		textField: {
			backgroundColor: 'white',
			height: '100%',
			width: '100%',
		},
		textInputField: {
			height: '100%',
		},

		checkbox: {
			height: 36,
			width: 36,
		},
		greyCellOfcomment: {
			backgroundColor: 'rgb(247, 247, 247)',
			height: '80px',
		},

		headerName: {
			backgroundColor: 'rgba(55, 135, 189, 0.61)',
			color: 'white',
			height: '100px',
			minWidth: '100px',
			textAlign: 'left',
			width: '160px',
		},
		headerNameA: {
			backgroundColor: 'rgba(55, 135, 189, 0.61)',
			color: 'white',
			height: '100px',
			textAlign: 'left',
			width: '166px',
		},
		paper: {
			minWidth: '700px',
			overflow: 'auto',
		},
		root: {
			flexGrow: 1,
			padding: 18,
		},
		wrapDiv: {
			margin: '10px',
		},
	});

export interface IStayMealdata {
	careerID: string;
	classId: string;
	preStay?: string;
	dayStay?: string;
	smoking?: string;
	sex?: string;
	preMealMorning?: string;
	preMealAfternoon?: string;
	preMealEvening?: string;
	dayMealMorning?: string;
	dayMealAfternoon?: string;
	dayMealEvening?: string;
	postMealMorning?: string;
	postMealAfternoon?: string;
	postMealEvening?: string;
}
export interface IClassStayMealInfo {
	ExecutionDate: string;
	StayFlg: string;
	MealMorningFlg: string;
	MealAfternoonFlg: string;
	MealEveningFlg: string;
}

interface IState {
	StayMealData: IClassStayMealInfo[];
	smoking: string;
	sex: string;
	Comment: string;
	sexAndsmokingFlg: boolean;
	errorDialogOpen: boolean;
	errorDialogContent: string;
	errorDialogReplacements: string[];
}

class CareerStayMeal extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
		this.state = {
			Comment: '',
			StayMealData: [],
			errorDialogContent: '',
			errorDialogOpen: false,
			errorDialogReplacements: [],
			sex: '0',
			sexAndsmokingFlg: true,
			smoking: '0',
		};
		this.closeErrorDialog = this.closeErrorDialog.bind(this);
		this.closeStayMealDialog = this.closeStayMealDialog.bind(this);
	}
	public componentDidMount() {
		if (this.props.comment !== '' && this.props.comment) {
			this.setState({
				Comment: this.props.comment,
			});
		}
		const list: IApprovalStayMealData[] = JSON.parse(
			JSON.stringify(this.props.ApprovalDateList)
		);
		if (list.length !== 0) {
			// tslint:disable-next-line:prefer-for-of
			for (let index = 0; index < list.length; index++) {
				if (
					list[index]['careerID'] ===
						this.props.StayMealdata.careerID &&
					list[index]['classID'] === this.props.StayMealdata.classId
				) {
					this.setState({
						Comment: list[index]['Comment'],
						StayMealData: list[index]['StayMealDateList'],
						sex: list[index]['SexFlg'],
						smoking: list[index]['SmokingFlg'],
					});

					let setSexAndSmokingFlg = false;
					// tslint:disable-next-line:prefer-for-of
					for (
						let x = 0;
						x < list[index]['StayMealDateList'].length;
						x++
					) {
						if (
							list[index]['StayMealDateList'][x].StayFlg === '1'
						) {
							setSexAndSmokingFlg = true;
							this.setState({
								sexAndsmokingFlg: false,
							});
							return;
						}
					}

					if (setSexAndSmokingFlg === false) {
						this.setState({
							sex: '0',
							sexAndsmokingFlg: true,
							smoking: '0',
						});
					}
				}
			}
		}
	}

	public render() {
		const { classes } = this.props;
		return (
			<div className={classes.root}>
				<div className={classes.wrapDiv}>
					<Paper className={classes.paper}>
						{this.props.dateList && (
							<Table className={classes.tableStyle}>
								<TableBody>
									<TableRow>
										<TableCell
											colSpan={2}
											className={classes.headerNameA}
											classes={{
												root: classes.CellBorder,
											}}
										/>
										{this.props.dateList.map(
											(
												item: IStayMealDateList,
												index: number
											) => {
												let week = item.week.substring(
													0,
													1
												);
												if (i18n.language !== 'ja') {
													week = i18n.t(item.week, {
														ns: 'force',
													});
												}
												return (
													<TableCell
														className={
															classes.headerName
														}
														key={index}
														classes={{
															root:
																classes.CellBorder,
														}}
													>
														{index === 0 &&
															i18n.t(
																'CareerStayMeal_0001'
															)}
														{index > 0 &&
															index <
																this.props
																	.dateList
																	.length -
																	1 &&
															i18n.t(
																'CareerStayMeal_0002'
															)}
														{index ===
															this.props.dateList
																.length -
																1 &&
															i18n.t(
																'CareerStayMeal_0003'
															)}
														<br />
														{item.date}(
														{item.week && week})
													</TableCell>
												);
											},
											this
										)}
									</TableRow>
									<TableRow>
										<TableCell
											rowSpan={3}
											classes={{
												root: classes.cellBorderOftitle,
											}}
											className={classes.greycellOfTitle}
										>
											{i18n.t('CareerStayMeal_0004')}
										</TableCell>
										<TableCell
											classes={{
												root: classes.CellBorder,
											}}
											className={classes.greyCell}
										/>
										{this.props.dateList.map(
											(
												item: IStayMealDateList,
												index: number
											) => {
												return (
													<TableCell
														key={index}
														classes={{
															root:
																classes.CellBorder,
														}}
														className={
															classes.greyCell
														}
													>
														{index === 0 &&
															this.props
																.StayMealdata
																.preStay ===
																'1' && (
																<FormControlLabel
																	control={
																		<Checkbox
																			key={
																				index
																			}
																			className={
																				this
																					.props
																					.classes
																					.checkbox
																			}
																			checked={this.stayMealchecked(
																				'StayFlg',
																				item
																			)}
																			color={
																				'primary'
																			}
																			onClick={this.handleStayMealcheck(
																				'StayFlg',
																				item
																			)}
																		/>
																	}
																	label={i18n.t(
																		'CareerStayMeal_0005'
																	)}
																/>
															)}
														{index > 0 &&
															index <
																this.props
																	.dateList
																	.length -
																	1 &&
															this.props
																.StayMealdata
																.dayStay ===
																'1' && (
																<FormControlLabel
																	control={
																		<Checkbox
																			key={
																				index
																			}
																			className={
																				this
																					.props
																					.classes
																					.checkbox
																			}
																			checked={this.stayMealchecked(
																				'StayFlg',
																				item
																			)}
																			color={
																				'primary'
																			}
																			onClick={this.handleStayMealcheck(
																				'StayFlg',
																				item
																			)}
																		/>
																	}
																	label={i18n.t(
																		'CareerStayMeal_0005'
																	)}
																/>
															)}
													</TableCell>
												);
											},
											this
										)}
									</TableRow>
									<TableRow>
										<TableCell
											classes={{
												root: classes.cellgreyborder,
											}}
											className={classes.whiteCell}
										>
											{i18n.t('CareerStayMeal_0006')}
										</TableCell>
										<TableCell
											colSpan={this.props.dateList.length}
											className={classes.whiteCell}
											classes={{
												root: classes.cellgreyborder,
											}}
										>
											{this.props.StayMealdata.sex ===
												'1' &&
												(this.props.StayMealdata
													.dayStay === '1' ||
													this.props.StayMealdata
														.preStay === '1') && (
													<>
														<FormControlLabel
															control={
																<Checkbox
																	className={
																		this
																			.props
																			.classes
																			.checkbox
																	}
																	disabled={
																		this
																			.state
																			.sexAndsmokingFlg
																	}
																	checked={
																		this
																			.state
																			.sex ===
																		'1'
																	}
																	color={
																		'primary'
																	}
																	onClick={this.handleSexAndSmokeCheck(
																		'male'
																	)}
																/>
															}
															label={i18n.t(
																'CareerStayMeal_0007'
															)}
														/>
														&nbsp;&nbsp;
														<FormControlLabel
															control={
																<Checkbox
																	className={
																		this
																			.props
																			.classes
																			.checkbox
																	}
																	checked={
																		this
																			.state
																			.sex ===
																		'2'
																	}
																	disabled={
																		this
																			.state
																			.sexAndsmokingFlg
																	}
																	color={
																		'primary'
																	}
																	onClick={this.handleSexAndSmokeCheck(
																		'female'
																	)}
																/>
															}
															label={i18n.t(
																'CareerStayMeal_0008'
															)}
														/>
													</>
												)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											classes={{
												root: classes.CellBorder,
											}}
											className={classes.greyCell}
										>
											{i18n.t('CareerStayMeal_0009')}
										</TableCell>
										<TableCell
											colSpan={this.props.dateList.length}
											classes={{
												root: classes.CellBorder,
											}}
											className={classes.greyCell}
										>
											{this.props.StayMealdata.smoking ===
												'1' &&
												(this.props.StayMealdata
													.preStay === '1' ||
													this.props.StayMealdata
														.dayStay === '1') && (
													<>
														<FormControlLabel
															control={
																<Checkbox
																	className={
																		this
																			.props
																			.classes
																			.checkbox
																	}
																	checked={
																		this
																			.state
																			.smoking ===
																		'1'
																	}
																	disabled={
																		this
																			.state
																			.sexAndsmokingFlg
																	}
																	color={
																		'primary'
																	}
																	onClick={this.handleSexAndSmokeCheck(
																		'NoSmoking'
																	)}
																/>
															}
															label={i18n.t(
																'CareerStayMeal_0010'
															)}
														/>
														&nbsp;&nbsp;
														<FormControlLabel
															control={
																<Checkbox
																	className={
																		this
																			.props
																			.classes
																			.checkbox
																	}
																	checked={
																		this
																			.state
																			.smoking ===
																		'2'
																	}
																	disabled={
																		this
																			.state
																			.sexAndsmokingFlg
																	}
																	color={
																		'primary'
																	}
																	onClick={this.handleSexAndSmokeCheck(
																		'Smoking'
																	)}
																/>
															}
															label={i18n.t(
																'CareerStayMeal_0011'
															)}
														/>
													</>
												)}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											rowSpan={3}
											classes={{
												root:
													classes.cellgreyBorderOftitle,
											}}
											className={classes.cellOfTitle}
										>
											{i18n.t('CareerStayMeal_0012')}
										</TableCell>
										<TableCell
											classes={{
												root: classes.cellgreyborder,
											}}
										>
											{i18n.t('CareerStayMeal_0013')}
										</TableCell>
										{this.props.dateList.map(
											(
												item: IStayMealDateList,
												index: number
											) => {
												return (
													<TableCell
														key={index}
														className={
															classes.whiteCell
														}
														classes={{
															root:
																classes.cellgreyborder,
														}}
													>
														{this.props.StayMealdata
															.preMealMorning ===
															'1' &&
															index === 0 && (
																<>
																	<FormControlLabel
																		control={
																			<Checkbox
																				key={
																					index
																				}
																				className={
																					this
																						.props
																						.classes
																						.checkbox
																				}
																				checked={this.stayMealchecked(
																					'MealMorningFlg',
																					item
																				)}
																				color={
																					'primary'
																				}
																				onClick={this.handleStayMealcheck(
																					'MealMorningFlg',
																					item
																				)}
																			/>
																		}
																		label={i18n.t(
																			'CareerStayMeal_0005'
																		)}
																	/>
																</>
															)}
														{this.props.StayMealdata
															.dayMealMorning ===
															'1' &&
															index > 0 &&
															index <
																this.props
																	.dateList
																	.length -
																	1 && (
																<>
																	<FormControlLabel
																		control={
																			<Checkbox
																				key={
																					index
																				}
																				className={
																					this
																						.props
																						.classes
																						.checkbox
																				}
																				checked={this.stayMealchecked(
																					'MealMorningFlg',
																					item
																				)}
																				color={
																					'primary'
																				}
																				onClick={this.handleStayMealcheck(
																					'MealMorningFlg',
																					item
																				)}
																			/>
																		}
																		label={i18n.t(
																			'CareerStayMeal_0005'
																		)}
																	/>
																</>
															)}
														{this.props.StayMealdata
															.postMealMorning ===
															'1' &&
															index ===
																this.props
																	.dateList
																	.length -
																	1 && (
																<>
																	<FormControlLabel
																		control={
																			<Checkbox
																				key={
																					index
																				}
																				className={
																					this
																						.props
																						.classes
																						.checkbox
																				}
																				checked={this.stayMealchecked(
																					'MealMorningFlg',
																					item
																				)}
																				color={
																					'primary'
																				}
																				onClick={this.handleStayMealcheck(
																					'MealMorningFlg',
																					item
																				)}
																			/>
																		}
																		label={i18n.t(
																			'CareerStayMeal_0005'
																		)}
																	/>
																</>
															)}
													</TableCell>
												);
											},
											this
										)}
									</TableRow>
									<TableRow>
										<TableCell
											className={classes.greyCell}
											classes={{
												root: classes.CellBorder,
											}}
										>
											{i18n.t('CareerStayMeal_0014')}
										</TableCell>
										{this.props.dateList.map(
											(
												item: IStayMealDateList,
												index: number
											) => {
												return (
													<TableCell
														key={index}
														classes={{
															root:
																classes.CellBorder,
														}}
														className={
															classes.greyCell
														}
													>
														{this.props.StayMealdata
															.preMealAfternoon ===
															'1' &&
															index === 0 && (
																<>
																	<FormControlLabel
																		control={
																			<Checkbox
																				key={
																					index
																				}
																				className={
																					this
																						.props
																						.classes
																						.checkbox
																				}
																				checked={this.stayMealchecked(
																					'MealAfternoonFlg',
																					item
																				)}
																				color={
																					'primary'
																				}
																				onClick={this.handleStayMealcheck(
																					'MealAfternoonFlg',
																					item
																				)}
																			/>
																		}
																		label={i18n.t(
																			'CareerStayMeal_0005'
																		)}
																	/>
																</>
															)}
														{this.props.StayMealdata
															.dayMealAfternoon ===
															'1' &&
															index > 0 &&
															index <
																this.props
																	.dateList
																	.length -
																	1 && (
																<>
																	<FormControlLabel
																		control={
																			<Checkbox
																				key={
																					index
																				}
																				className={
																					this
																						.props
																						.classes
																						.checkbox
																				}
																				checked={this.stayMealchecked(
																					'MealAfternoonFlg',
																					item
																				)}
																				color={
																					'primary'
																				}
																				onClick={this.handleStayMealcheck(
																					'MealAfternoonFlg',
																					item
																				)}
																			/>
																		}
																		label={i18n.t(
																			'CareerStayMeal_0005'
																		)}
																	/>
																</>
															)}
														{this.props.StayMealdata
															.postMealAfternoon ===
															'1' &&
															index ===
																this.props
																	.dateList
																	.length -
																	1 && (
																<>
																	<FormControlLabel
																		control={
																			<Checkbox
																				key={
																					index
																				}
																				className={
																					this
																						.props
																						.classes
																						.checkbox
																				}
																				checked={this.stayMealchecked(
																					'MealAfternoonFlg',
																					item
																				)}
																				color={
																					'primary'
																				}
																				onClick={this.handleStayMealcheck(
																					'MealAfternoonFlg',
																					item
																				)}
																			/>
																		}
																		label={i18n.t(
																			'CareerStayMeal_0005'
																		)}
																	/>
																</>
															)}
													</TableCell>
												);
											},
											this
										)}
									</TableRow>
									<TableRow>
										<TableCell
											classes={{
												root: classes.cellgreyborder,
											}}
										>
											{i18n.t('CareerStayMeal_0015')}
										</TableCell>
										{this.props.dateList.map(
											(
												item: IStayMealDateList,
												index: number
											) => {
												return (
													<TableCell
														key={index}
														className={
															classes.whiteCell
														}
														classes={{
															root:
																classes.cellgreyborder,
														}}
													>
														{this.props.StayMealdata
															.preMealEvening ===
															'1' &&
															index === 0 && (
																<>
																	<FormControlLabel
																		control={
																			<Checkbox
																				key={
																					index
																				}
																				className={
																					this
																						.props
																						.classes
																						.checkbox
																				}
																				checked={this.stayMealchecked(
																					'MealEveningFlg',
																					item
																				)}
																				color={
																					'primary'
																				}
																				onClick={this.handleStayMealcheck(
																					'MealEveningFlg',
																					item
																				)}
																			/>
																		}
																		label={i18n.t(
																			'CareerStayMeal_0005'
																		)}
																	/>
																</>
															)}
														{this.props.StayMealdata
															.dayMealEvening ===
															'1' &&
															index > 0 &&
															index <
																this.props
																	.dateList
																	.length -
																	1 && (
																<>
																	<FormControlLabel
																		control={
																			<Checkbox
																				key={
																					index
																				}
																				className={
																					this
																						.props
																						.classes
																						.checkbox
																				}
																				checked={this.stayMealchecked(
																					'MealEveningFlg',
																					item
																				)}
																				color={
																					'primary'
																				}
																				onClick={this.handleStayMealcheck(
																					'MealEveningFlg',
																					item
																				)}
																			/>
																		}
																		label={i18n.t(
																			'CareerStayMeal_0005'
																		)}
																	/>
																</>
															)}
														{this.props.StayMealdata
															.postMealEvening ===
															'1' &&
															index ===
																this.props
																	.dateList
																	.length -
																	1 && (
																<>
																	<FormControlLabel
																		control={
																			<Checkbox
																				key={
																					index
																				}
																				className={
																					this
																						.props
																						.classes
																						.checkbox
																				}
																				checked={this.stayMealchecked(
																					'MealEveningFlg',
																					item
																				)}
																				color={
																					'primary'
																				}
																				onClick={this.handleStayMealcheck(
																					'MealEveningFlg',
																					item
																				)}
																			/>
																		}
																		label={i18n.t(
																			'CareerStayMeal_0005'
																		)}
																	/>
																</>
															)}
													</TableCell>
												);
											},
											this
										)}
									</TableRow>
									<TableRow>
										<TableCell
											colSpan={2}
											classes={{
												root: classes.CellBorder,
											}}
											className={
												classes.greyCellOfcomment
											}
										>
											{i18n.t('CareerStayMeal_0016')}
										</TableCell>
										<TableCell
											colSpan={this.props.dateList.length}
											classes={{
												root: classes.CellBorder,
											}}
											className={
												classes.greyCellOfcomment
											}
										>
											<TextField
												variant={'outlined'}
												className={classes.textField}
												classes={{
													root:
														classes.textInputField,
												}}
												value={this.state.Comment}
												onChange={this.handleComment}
												multiline={true}
												rows="3"
											/>
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						)}
					</Paper>
					<div className={classes.button}>
						<Grid container={true} justify={'center'} spacing={3}>
							<Grid item={true}>
								<Button
									variant="contained"
									color="primary"
									onClick={this.ApprovalStayMeal}
								>
									{i18n.t('CareerStayMeal_0017')}
								</Button>
							</Grid>
							<Grid item={true}>
								<Button
									variant="contained"
									color="default"
									onClick={this.closeStayMealDialog}
								>
									{i18n.t('CareerStayMeal_0018')}
								</Button>
							</Grid>
						</Grid>
					</div>
					<MessageDialog
						open={this.state.errorDialogOpen}
						showCancelButton={false}
						title={i18n.t('CareerStayMeal_0019')}
						contents={[
							{
								content: this.state.errorDialogContent,
								replacements: this.state
									.errorDialogReplacements,
							},
						]}
						onClose={this.closeErrorDialog}
						onClickOk={this.closeErrorDialog}
					/>
				</div>
			</div>
		);
	}
	protected closeErrorDialog() {
		this.setState({ errorDialogOpen: false });
	}

	protected closeStayMealDialog = (event: React.MouseEvent<HTMLElement>) => {
		this.props.setClassStayMealDialog(false);
	};

	protected handleComment = (event: React.ChangeEvent<HTMLInputElement>) => {
		const target = event.target as HTMLInputElement;
		this.setState({
			Comment: target.value,
		});
	};

	protected ApprovalStayMeal = (event: React.MouseEvent<HTMLElement>) => {
		if (this.state.Comment.length > 1000) {
			this.setState({
				errorDialogContent: 'CHK_E_0004',
				errorDialogOpen: true,
				errorDialogReplacements: [
					i18n.t('CareerStayMeal_0016'),
					'1000',
				],
			});
			return;
		}
		const StayMealDateList: IClassStayMealInfo[] = [];
		const list = JSON.parse(JSON.stringify(this.state.StayMealData));
		// tslint:disable-next-line:prefer-for-of
		for (let index = 0; index < list.length; index++) {
			if (
				list[index]['StayFlg'] === '1' ||
				list[index]['MealMorningFlg'] === '1' ||
				list[index]['MealAfternoonFlg'] === '1' ||
				list[index]['MealEveningFlg'] === '1'
			) {
				StayMealDateList.push(list[index]);
			}
		}

		const ApprovalList = JSON.parse(
			JSON.stringify(this.props.ApprovalDateList)
		);
		let addflg = true;
		if (ApprovalList.length !== 0) {
			// tslint:disable-next-line:prefer-for-of
			for (let index = 0; index < ApprovalList.length; index++) {
				if (
					ApprovalList[index]['careerID'] ===
						this.props.StayMealdata.careerID &&
					ApprovalList[index]['classID'] ===
						this.props.StayMealdata.classId
				) {
					addflg = false;
					ApprovalList[index].StayMealDateList = StayMealDateList;
					ApprovalList[index].Comment = this.state.Comment;
					ApprovalList[index].SexFlg = this.state.sex;
					ApprovalList[index].SmokingFlg = this.state.smoking;
				}
				if (
					ApprovalList[index]['careerID'] ===
					this.props.StayMealdata.careerID
				) {
					ApprovalList[index].Comment = this.state.Comment;
				}
			}
		}
		if (addflg) {
			const param: IApprovalStayMealData = {
				careerID: this.props.StayMealdata.careerID,
				classID: this.props.StayMealdata.classId,

				Comment: this.state.Comment,
				SexFlg: this.state.sex,
				SmokingFlg: this.state.smoking,
				StayMealDateList,
				UID: this.props.userAttr.userId,
			};
			ApprovalList.push(param);
		}
		this.props.setApprovalStayMealList(ApprovalList);
		this.props.stayMealComment(this.state.Comment);
		this.props.setClassStayMealDialog(false);
	};

	protected handleSexAndSmokeCheck = (flagName: string) => (
		event: React.MouseEvent<HTMLElement>
	) => {
		if (flagName === 'male') {
			if (this.state.sex === '1') {
				this.setState({
					sex: '0',
				});
			} else {
				this.setState({
					sex: '1',
				});
			}
		}
		if (flagName === 'female') {
			if (this.state.sex === '2') {
				this.setState({
					sex: '0',
				});
			} else {
				this.setState({
					sex: '2',
				});
			}
		}
		if (flagName === 'Smoking') {
			if (this.state.smoking === '2') {
				this.setState({
					smoking: '0',
				});
			} else {
				this.setState({
					smoking: '2',
				});
			}
		}
		if (flagName === 'NoSmoking') {
			if (this.state.smoking === '1') {
				this.setState({
					smoking: '0',
				});
			} else {
				this.setState({
					smoking: '1',
				});
			}
		}
	};

	protected stayMealchecked = (flagName: string, item: IStayMealDateList) => {
		const list = this.state.StayMealData;
		if (list.length === 0) {
			return false;
		}
		// tslint:disable-next-line:prefer-for-of
		for (let index = 0; index < list.length; index++) {
			if (list[index].ExecutionDate === item.executionDate) {
				if (list[index][flagName] === '0') {
					return false;
				} else {
					return true;
				}
			}
		}
		return false;
	};

	protected handleStayMealcheck = (
		flagName: string,
		item: IStayMealDateList
	) => (event: React.MouseEvent<HTMLElement>) => {
		const Templist = this.state.StayMealData;
		if (Templist.length === 0) {
			const stayMealParam: IClassStayMealInfo = {
				ExecutionDate: item.executionDate,
				MealAfternoonFlg: '0',
				MealEveningFlg: '0',
				MealMorningFlg: '0',
				StayFlg: '0',
			};
			if (stayMealParam[flagName] === '0') {
				stayMealParam[flagName] = '1';
			} else {
				stayMealParam[flagName] = '0';
			}
			Templist.push(stayMealParam);
			this.setState({ StayMealData: Templist });
		} else {
			let addflg = true;
			// tslint:disable-next-line:prefer-for-of
			for (let index = 0; index < Templist.length; index++) {
				if (Templist[index].ExecutionDate === item.executionDate) {
					addflg = false;
					if (Templist[index][flagName] === '0') {
						Templist[index][flagName] = '1';
					} else {
						Templist[index][flagName] = '0';
					}
					this.setState({ StayMealData: Templist });
				}
			}
			if (addflg) {
				const stayMealParam: IClassStayMealInfo = {
					ExecutionDate: item.executionDate,
					MealAfternoonFlg: '0',
					MealEveningFlg: '0',
					MealMorningFlg: '0',
					StayFlg: '0',
				};
				if (stayMealParam[flagName] === '0') {
					stayMealParam[flagName] = '1';
				} else {
					stayMealParam[flagName] = '0';
				}
				Templist.push(stayMealParam);
				this.setState({ StayMealData: Templist });
			}
		}

		let setSexAndSmokingFlg = false;
		// tslint:disable-next-line:prefer-for-of
		for (let index = 0; index < this.state.StayMealData.length; index++) {
			if (this.state.StayMealData[index].StayFlg === '1') {
				setSexAndSmokingFlg = true;
				this.setState({
					sexAndsmokingFlg: false,
				});
				return;
			}
		}

		if (setSexAndSmokingFlg === false) {
			this.setState({
				sex: '0',
				sexAndsmokingFlg: true,
				smoking: '0',
			});
		}
	};
}

const mapStateToProps = (state: IRootState) => ({
	ApprovalDateList: state.search.approvalStayMealList,
	dateList: state.search.stayMealDateList,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	pushHistory: (path: string) => dispatch(push(path)),
	setApprovalStayMealList: (approvalStayMealList: IApprovalStayMealData[]) =>
		dispatch(setApprovalStayMealList({ approvalStayMealList })),
	setClassStayMealDialog: (OpenClassStayMealDialog: boolean) =>
		dispatch(setClassStayMealDialog({ OpenClassStayMealDialog })),
	stayMealComment: (comment: string) =>
		dispatch(setStayMealCommment({ comment })),
});

export interface ICareerStayMealProps {
	StayMealdata: IStayMealdata;
	comment: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ICareerStayMealProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CareerStayMeal);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/CareerStayMeal.tsx